<template>
  <div class="overflow-y-scroll">
    <section>
      <fieldset
        class="form-field"
        v-for="(refe, index) in editReferences"
        :key="index"
      >
        <div class="form-inline flex-row">
          <legend>
            Reference #{{ index }}:
            <a
              href="javascript:void(0)"
              class="input-prepend-btn"
              @click="addReference(index)"
            >
              <i class="material-icons-outlined align-middle">add</i>
            </a>
            <a
              href="javascript:void(0)"
              class="input-apend-btn"
              @click="deleteReference(index)"
            >
              <i class="material-icons-outlined align-middle">delete</i>
            </a>
          </legend>
        </div>
        <div class="form-inline flex-row">
          <label :for="`content-${index}`">Content:</label>
          <div>
            <textarea
              :id="`content-${index}`"
              rows="3"
              placeholder="Content"
              v-model="editReferences[index].content"
            />
          </div>
        </div>
        <div class="form-inline flex-row">
          <label :for="`signature-${index}`">Signature:</label>
          <div class="input-group">
            <input
              :id="`signature-${index}`"
              type="text"
              placeholder="Signature"
              v-model="editReferences[index].signature"
            />
          </div>
        </div>
      </fieldset>
      <div class="form-inline flex-row">
        <button class="submit primary" @click="onButtonClick">
          Edit References
        </button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: ["propsData"],
  watch: {
    refes: function () {
      this.initData();
    },
  },
  data() {
    return {
      editReferences: null,
    };
  },
  created: function () {
    this.initData();
  },
  methods: {
    addReference: function (index) {
      this.editReferences.splice(index + 1, 0, {});
    },
    deleteReference: function (index) {
      this.editReferences.splice(index, 1);
      if (this.editReferences.length == 0) {
        this.editReferences.push({});
      }
    },
    initData: function () {
      const propsData = Object.assign([{}], this.propsData);
      if (propsData) {
        this.editReferences = propsData;
      } else {
        this.editReferences = [{}];
      }
    },
    onButtonClick: function () {
      const data = [];
      this.editReferences.forEach((item) => {
        if (item.content || item.signature) {
          data.push(item);
        }
      });
      this.$emit("onButtonClick", data);
    },
  },
};
</script>
